export const list = {
  selector: '.v-list',
  reactive: true,

  run(el) {

    el.setAttribute('role', 'list');
    // el.setAttribute('tabindex', '0');
    if (!el.hasAttribute('aria-label') && !el.hasAttribute('aria-labelledby')) {
      el.setAttribute('aria-label', 'List');
    }

    if(!el.getAttribute('tabindex')) return;
    
    const items = Array.from(el.querySelectorAll('a.v-list-item, button.v-list-item, [tabindex="0"]'));
    if (!items.length) return;

    const getFocusable = container =>
      Array.from(container.querySelectorAll('button, a'))
        .filter(x => !x.disabled && x.offsetParent !== null);

    let currentItem = -1;
    let currentChild = -1;

    const focusContainer = () => {
      el.focus();
      currentItem = -1;
      currentChild = -1;
    };

    const focusAt = (itemIdx, childIdx = -1) => {
      const item = items[itemIdx];
      const focusables = getFocusable(item);

      if (childIdx === -1 || focusables.length === 0) {
        item.focus();
        currentItem = itemIdx;
        currentChild = -1;
      } else {
        focusables[childIdx].focus();
        currentItem = itemIdx;
        currentChild = childIdx;
      }
    };

    const handleArrowDown = () => {
      if (currentItem === -1) {
        // from container → first item
        focusAt(0, -1);
      } else {
        const focusables = getFocusable(items[currentItem]);

        if (currentChild < focusables.length - 1) {
          // next child
          focusAt(currentItem, currentChild + 1);
        } else if (currentItem < items.length - 1) {
          // next item
          focusAt(currentItem + 1, -1);
        } else {
          // end → back to container
          focusContainer();
        }
      }
    };

    const handleArrowUp = () => {
      if (currentItem === -1) {
        // from container → last item
        focusAt(items.length - 1, -1);
      } else {
        const focusables = getFocusable(items[currentItem]);

        if (currentChild < focusables.length - 1) {
          // move into next child (forward order)
          focusAt(currentItem, currentChild + 1);
        } else if (currentItem > 0) {
          // previous item
          focusAt(currentItem - 1, -1);
        } else {
          // top → back to container
          focusContainer();
        }
      }
    };

    // keydown on the list container
    el.addEventListener('keydown', e => {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        handleArrowDown();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        handleArrowUp();
      } else if (e.key === 'Tab') {
        // let Tab exit
        currentItem = -1;
        currentChild = -1;
      }
    });

    // make items & their focusables programmatically focusable
    items.forEach(item => {
      if (!item.hasAttribute('tabindex')) item.setAttribute('tabindex', '-1');
      getFocusable(item).forEach(ch => {
        if (!ch.hasAttribute('tabindex')) ch.setAttribute('tabindex', '-1');
      });
    });

    // start on container
    focusContainer();
  }
};
